"use client";

// packages/eden-table/src/components/TD.jsx
import styled from "styled-components";
import { spacing16, spacing8 } from "@churchofjesuschrist/eden-style-constants";
import { jsx } from "react/jsx-runtime";
var Root = styled.td`
  padding: calc(
      ${({ $dataType }) => $dataType === "controls" ? spacing8 : spacing16} /
        var(--eden-table-density-divisor, 1)
    )
    calc(${spacing16} / var(--eden-table-density-divisor, 1));

  text-align: ${({ $dataType }) => $dataType === "number" ? "end" : "start"};
`;
var TD = ({ children, type = "normal", ...props }) => /* @__PURE__ */ jsx(Root, { ...props, $dataType: type, children });
TD.displayName = "TD";
var TD_default = TD;
export {
  TD_default as default
};
